<p-drawer [(visible)]="visible" position="right" [showCloseIcon]="false" [modal]="true"
  styleClass="filters-drawer w-[320px] max-w-[90vw]" (onHide)="close()">

  <!-- Header custom -->
  <ng-template pTemplate="header">
    <div class="flex flex-col gap-2 w-full mt-3">
      <div class="flex items-center justify-between w-full">
        <div class="flex items-center gap-2">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.66745 7.16716H6.49127C6.85123 8.49159 8.21669 9.27345 9.54113 8.91349C10.3918 8.68229 11.0563 8.0178 11.2875 7.16716H19.3327C19.7008 7.16716 19.9993 6.86872 19.9993 6.50057C19.9993 6.13242 19.7008 5.83398 19.3327 5.83398H11.2875C10.9275 4.50951 9.56203 3.72765 8.2376 4.08762C7.38696 4.31881 6.72246 4.98331 6.49127 5.83395H4.66745C4.29929 5.83395 4.00085 6.13239 4.00085 6.50054C4.00085 6.86869 4.29929 7.16716 4.66745 7.16716Z" fill="#535353"/>
            <path d="M19.3327 11.3334H17.5088C17.1496 10.0092 15.7849 9.22686 14.4606 9.58608C13.6093 9.81703 12.9443 10.4821 12.7133 11.3334H4.66745C4.29929 11.3334 4.00085 11.6318 4.00085 12C4.00085 12.3682 4.29929 12.6666 4.66745 12.6666H12.7133C13.0726 13.9908 14.4373 14.7731 15.7615 14.4139C16.6128 14.183 17.2779 13.5179 17.5088 12.6666H19.3327C19.7008 12.6666 19.9993 12.3682 19.9993 12C19.9993 11.6318 19.7008 11.3334 19.3327 11.3334Z" fill="#535353"/>
            <path d="M19.3327 16.8329H11.2875C10.9275 15.5084 9.56203 14.7266 8.2376 15.0865C7.38696 15.3177 6.72246 15.9822 6.49127 16.8329H4.66745C4.29929 16.8329 4.00085 17.1313 4.00085 17.4995C4.00085 17.8676 4.29929 18.1661 4.66745 18.1661H6.49127C6.85123 19.4905 8.21669 20.2723 9.54113 19.9124C10.3918 19.6812 11.0563 19.0167 11.2875 18.1661H19.3327C19.7008 18.1661 19.9993 17.8676 19.9993 17.4995C19.9993 17.1313 19.7008 16.8329 19.3327 16.8329Z" fill="#535353"/>
          </svg>
          <span class="filtros-title">Filtros</span>
        </div>
        <button class="p-0 border-0 bg-transparent rounded p-1" (click)="close()">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.6602 11.9699L19.4566 7.16859C19.768 6.81465 19.9329 6.35542 19.9179 5.88423C19.9029 5.41305 19.7089 4.96527 19.3756 4.63192C19.0422 4.29857 18.5945 4.10467 18.1233 4.08962C17.6521 4.07458 17.1929 4.23952 16.8389 4.55093L12.0376 9.34729L7.22765 4.53609C7.05536 4.36381 6.85083 4.22714 6.62573 4.1339C6.40063 4.04067 6.15937 3.99268 5.91573 3.99268C5.67208 3.99268 5.43082 4.04067 5.20572 4.1339C4.98062 4.22714 4.77609 4.36381 4.60381 4.53609C4.43152 4.70837 4.29486 4.91291 4.20162 5.13801C4.10838 5.36311 4.06039 5.60437 4.06039 5.84801C4.06039 6.09166 4.10838 6.33292 4.20162 6.55802C4.29486 6.78312 4.43152 6.98765 4.60381 7.15993L9.41501 11.9699L4.61864 16.77C4.43054 16.9381 4.27872 17.1429 4.17247 17.3717C4.06622 17.6006 4.00778 17.8487 4.00073 18.1009C3.99367 18.3531 4.03814 18.6041 4.13142 18.8385C4.2247 19.0729 4.36484 19.2859 4.54324 19.4643C4.72165 19.6427 4.93458 19.7828 5.169 19.8761C5.40343 19.9694 5.65442 20.0138 5.90663 20.0068C6.15883 19.9997 6.40695 19.9413 6.63579 19.835C6.86463 19.7288 7.06939 19.577 7.23754 19.3889L12.0376 14.5925L16.8327 19.3889C17.1807 19.7368 17.6526 19.9323 18.1447 19.9323C18.6367 19.9323 19.1086 19.7368 19.4566 19.3889C19.8045 19.0409 20 18.569 20 18.0769C20 17.5849 19.8045 17.113 19.4566 16.765L14.6602 11.9699Z" fill="#737CFD"/>
          </svg>
        </button>
      </div>
      <small class="filtros-subtitle">Los cambios se aplican y guardan automáticamente</small>
    </div>
  </ng-template>

  <div>
    @if (form) {
    <form [formGroup]="form">
      <p-accordion [value]="['0', '1', '2', '3']" [multiple]="true">
        <!-- Estado -->
        <p-accordion-panel value="0">
          <p-accordion-header class="pt-0 !important">Estado</p-accordion-header>
          <p-accordion-content>
            <div formGroupName="estado">
              <div class="flex items-center pt-2">
                <p-checkbox inputId="estado-todos" [binary]="true" formControlName="todos"></p-checkbox>
                <label for="estado-todos" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              <div class="flex items-center pt-2">
                <p-checkbox inputId="estado-habilitado" [binary]="true" formControlName="habilitado"></p-checkbox>
                <label for="estado-habilitado" class="ml-2 cursor-pointer filter-label">Habilitado</label>
              </div>
              <div class="flex items-center pt-2">
                <p-checkbox inputId="estado-deshabilitado" [binary]="true" formControlName="deshabilitado"></p-checkbox>
                <label for="estado-deshabilitado" class="ml-2 cursor-pointer filter-label">Deshabilitado</label>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <!-- Tipo -->
        <p-accordion-panel value="1">
          <p-accordion-header>Tipo</p-accordion-header>
          <p-accordion-content>
            <div formGroupName="tipo">
              <div class="flex items-center pt-2">
                <p-checkbox inputId="tipo-todos" [binary]="true" formControlName="todos"></p-checkbox>
                <label for="tipo-todos" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              <div class="flex items-center pt-2">
                <p-checkbox inputId="tipo-smartPOS" [binary]="true" formControlName="smartPOS"></p-checkbox>
                <label for="tipo-smartPOS" class="ml-2 cursor-pointer filter-label">SmartPOS</label>
              </div>
              <div class="flex items-center pt-2">
                <p-checkbox inputId="tipo-softPOS" [binary]="true" formControlName="softPOS"></p-checkbox>
                <label for="tipo-softPOS" class="ml-2 cursor-pointer filter-label">SoftPOS</label>
              </div>
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <!-- Comercio -->
        <p-accordion-panel value="2">
          <p-accordion-header>Comercio</p-accordion-header>
          <p-accordion-content>
            <div formGroupName="comercio" class="max-h-40 overflow-auto">
              <div class="flex items-center pt-2">
                <p-checkbox inputId="comercio-todos" [binary]="true" formControlName="todos"></p-checkbox>
                <label for="comercio-todos" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              @for (comercio of comercioControls; track $index) {
              <div class="flex items-center pt-2">
                <p-checkbox [inputId]="'comercio-' + comercio" [binary]="true" [formControlName]="comercio"></p-checkbox>
                <label [for]="'comercio-' + comercio" class="ml-2 cursor-pointer filter-label">{{ comercio }}</label>
              </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>

        <!-- Dispositivo -->
        <p-accordion-panel value="3">
          <p-accordion-header>Dispositivo</p-accordion-header>
          <p-accordion-content>
            <div formGroupName="dispositivo" class="max-h-40 overflow-auto">
              <div class="flex items-center pt-2">
                <p-checkbox inputId="dispositivo-todos" [binary]="true" formControlName="todos"></p-checkbox>
                <label for="dispositivo-todos" class="ml-2 cursor-pointer filter-label">Todos</label>
              </div>
              @for (dispositivo of dispositivoControls; track $index) {
              <div class="flex items-center pt-2">
                <p-checkbox [inputId]="'dispositivo-' + dispositivo" [binary]="true" [formControlName]="dispositivo"></p-checkbox>
                <label [for]="'dispositivo-' + dispositivo" class="ml-2 cursor-pointer filter-label">{{ dispositivo }}</label>
              </div>
              }
            </div>
          </p-accordion-content>
        </p-accordion-panel>
      </p-accordion>
    </form>
    }

    <button (click)="clear()"
      class="w-full flex items-center justify-center gap-2 p-3 mt-7 bg-transparent border-0"
      style="font-family: Inter; font-weight: 600; font-size: 16px; line-height: 100%; text-align: center;">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8.82112 8.94655L12.1358 5.6439C12.7646 5.01311 13.6034 4.66504 14.4962 4.66504C15.3891 4.66504 16.2273 5.01311 16.8574 5.64523L19.0271 7.82233C20.3201 9.11992 20.3201 11.2317 19.0271 12.5299L15.7118 15.8579L8.82112 8.94655ZM19.3332 18.0017H13.5767L14.771 16.8028L7.87627 9.88807L4.96969 12.784C3.67677 14.0816 3.67677 16.1933 4.96969 17.4909L6.02523 18.5505C6.522 19.0492 7.21014 19.3353 7.91494 19.3353H19.3332C19.7019 19.3353 20 19.0365 20 18.6685C20 18.3004 19.7019 18.0017 19.3332 18.0017Z" fill="#737CFD"/>
      </svg>
      Limpiar filtros
    </button>
  </div>
</p-drawer>